/**
 * @author NikolaV
 */

import './LogpointInfo.scss';
import * as React from 'react';
import { Ajax } from '@shared/Ajax';
import { Notify } from '@shared/ui-native/Notify';
import { LogpointProps } from '@shared/logpoints/ui/LogpointProps';
import { LogpointsEditor2dMap } from './LogpointsEditor2dMap';
import { LogpointApprovalsList } from '@shared/logpoints/ui/LogpointApprovalsList';
import { Events } from '@shared/Events';

// not pure
import { mapUI, mapRootStore, mapWrapper } from '../map';
import { LogpointsService } from '@shared/logpoints/LogpointsService';
import { Button } from '@shared/ui-react/Button';
import { LogpointHistoryDialog } from '@shared/logpoints/ui/LogpointHistoryDialog';
import { LogpointFeatureFactory } from '@openlayers/logpoints/LogpointFeatureFactory';


export class LogpointInfo extends React.Component<{
    logpointId: number,
}, {
    logpointData?: ILogpoint,
    mergedData?: ILogpoint,
    logpointApprovals?: ILogpointApproval[]
    latestApproval?: ILogpointApproval
    loading?: boolean
}> {
    state = {
        loading: true,
        logpointData: null,
        mergedData: null,
        logpointApprovals: null,
        latestApproval: null
    };

    componentDidMount() {
        this.fetch();
    }

    render() {
        const isLoading = this.state.loading;

        return (
            <div id="logpoint-info-popup" className={isLoading ? 'overlay-loading' : null}>
                {this.state.logpointData && <div>
                    {!kuura.hasPrivilege('LOGPOINTS_PAGE') && !!mapWrapper.featureLayers.logpoints ? null :
                        <div className='floating-window-toolbar' style={{ justifyContent: 'flex-start' }}>
                            {!(kuura.hasPrivilege('Edit_LogPoint') || kuura.hasPrivilege('SUPER_USER')) ? null :
                                <Button secondary subtle icon="pencil" className='toolbar-btn' tooltip={__('general.edit')} onClick={this.handleEdit} />}
                            <Button secondary subtle icon="clock2" className='toolbar-btn' tooltip={__('js_logpoints.activity_history')} onClick={() => LogpointHistoryDialog.openActivityHistory(this.props.logpointId)} />
                            {!(kuura.hasPrivilege('Delete_LogPoint') || kuura.hasPrivilege('SUPER_USER')) ? null :
                                <Button icon="iki iki-trash" className="toolbar-btn ik-button-secondary--subtle" onClick={this.handleDelete} tooltip={__('general.delete')} />}
                        </div>
                    }</div>
                }

                <div className='padded-half'>
                    <LogpointProps logpoint={this.state.mergedData} />

                    <LogpointApprovalsList onChangeApproval={this.handleChangeApproval} approvals={this.state.logpointApprovals}
                        latestApproval={this.state.latestApproval} />
                </div>
            </div>
        );
    }

    fetch = () => {
        this.setState({ loading: true });

        LogpointsService.fetchLogpoint(this.props.logpointId, mapRootStore.treeData).fail(Notify.error).always(() => this.setState({ loading: false })).done((resp: ILogpointWithApprovalsAjaxResponse) => {
            this.setState({
                logpointData: resp.logpointData,
                logpointApprovals: resp.logpointApprovalsData,
                latestApproval: resp.latestApproval,
                mergedData: {
                    ...resp.logpointData,
                    ...resp.ajaxLogpointData
                }
            });
        });
    };

    handleDelete = () => {
        if (confirm(__('js_logpoint.delete_confirm'))) {
            return Ajax({
                url: `api/1/logpoint/${this.props.logpointId}/delete.json`
            }).done(() => {
                if (mapWrapper.featureLayers.logpoints) {
                    mapWrapper.featureLayers.logpoints.removeFeatureById(this.props.logpointId);
                    Events.trigger('map-hide-overlays');
                }
                mapUI.mapPanels.panels.logpoints.genericComponent.renderLogpointFolderCounts();
                Notify.success();
            });
        }
    }

    handleEdit = () => {
        if (mapWrapper.featureLayers.logpoints) {
            const logpointFeature = mapWrapper.featureLayers.logpoints.getFeatureById(this.props.logpointId);
            if (logpointFeature) {
                const logpoints: ILogpoint[] = [mapWrapper.featureLayers.logpoints.getAjaxData(logpointFeature)];
                LogpointsEditor2dMap.open(logpoints, false, 'click', mapRootStore.treeData);
            }
        }
    }

    handleChangeApproval = (approvalStage: LogpointApprovalStage) => {
        if (!confirm(__('js_logpoints.approval.confirm'))) return;

        this.setState({ loading: true });

        Ajax({
            url: 'logpoints_bulk_edit.json',
            method: 'POST',
            data: {
                logpointIds: [this.props.logpointId],
                approvalStage
            }
        }).fail(Notify.error).always(() => this.setState({ loading: false })).done(resp => {
            LogpointFeatureFactory.clearCache();
            this.fetch();
            mapWrapper.featureLayers.logpoints.fetchAndDrawSingle(this.props.logpointId);
        });
    };
}
